import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClerk } from '@clerk/clerk-react';
import { Calendar } from 'lucide-react';

const CalendarSignInModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { openSignIn } = useClerk();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="flex items-center justify-center min-h-screen p-4">
        <div 
          className="w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              {t('sidebar.calendars')}
            </h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
            >
              <svg className="w-5 h-5 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-8">
            <div className="text-center text-gray-500 dark:text-gray-400">
              <p className="mb-2 font-bold">{t('signIn.calendarTitle')}</p>
              <p className="mb-6 text-sm">{t('signIn.calendarBody')}</p>
              <button
                onClick={() => openSignIn()}
                className="sign-in-button"
              >
                {t('buttons.signIn')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarSignInModal;